module.exports = "/images/Create your submittal log - 2.jpg";